import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function useRefinementTranslations() {
	const { t } = useTranslation();

	return useMemo(
		() => ({
			draft: t("draft", "Draft"),
			offer: t("offer", "Offer"),
			planning: t("planning", "Planning"),
			accepted: t("accepted", "Accepted"),
			production: t("producing", "Producing"),
			done: t("done", "Done"),
			backlist: t("backlist", "Backlist"),
			external: t("external", "External"),
			internal: t("internal", "Internal"),
			subcontractor: t("subcontractor", "Subcontractor"),
			audiodrama: t("audiodrama", "Audiodrama"),
			onevoice: t("onevoice", "Onevoice"),
			podcast: t("podcast", "Podcast"),
			cd: t("cd", "Cd"),
			eBook: t("eBook", "EBook"),
			mp3cd: t("mp3cd", "Mp3cd"),
			normal: t("normal", "Normal"),
			shared: t("shared", "Shared"),
		}),
		[t],
	);
}
